<template>
  <div ref="cell" class="grid-view__cell">
    <div class="grid-field-url">
      <img
        v-if="faviconUrl"
        class="grid-field-url__favicon"
        :src="faviconUrl"
        alt=""
        loading="lazy"
        referrerpolicy="no-referrer"
        @error="faviconError = true"
      />
      <!-- Styled as a link (blue, underlined) but NOT an <a>: the unselected
           cell must select on click like every other cell. The real clickable
           <a href> lives in the selected-cell component (GridViewFieldURL.vue),
           matching Baserow's select-then-interact model. -->
      <span class="grid-field-url__text">
        <SearchHighlightedText :text="value" :search-term="searchTerm" />
      </span>
    </div>
  </div>
</template>

<script>
import { getFaviconUrl } from '@baserow/modules/core/utils/url'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldURL',
  components: { SearchHighlightedText },
  props: {
    value: {
      type: String,
      default: '',
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      faviconError: false,
    }
  },
  computed: {
    faviconUrl() {
      if (this.faviconError) return null
      return getFaviconUrl(this.value)
    },
  },
  watch: {
    value() {
      this.faviconError = false
    },
  },
}
</script>
